import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import {
  authEndpoints,
  campaignEndpoints,
  CampaignSettingsEndpoints,
} from "../../../../utils/constants/httpConstants";
import { getErrorMessage } from "../../../../utils/helpers";
import {
  EMITTER_ERROR,
  EMITTER_SUCCESS,
  isOAuthMailboxEsp,
} from "../../../../utils/constants";
import { getRequest, postRequest } from "../../../../Apis";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { STRINGS } from "../../strings";
import CustomModal from "../../../../components/Modals/CustomModal";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { GREY, WARNING } from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";
import IconComponent from "../../../../components/Icon/IconComponent";
import { deleteRequest } from "../../../../Apis/apiWrapper";
import { useSelector } from "react-redux";
const styles = makeStyles({
  modal: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    overflowY: "auto",
    backgroundColor: "white",
    border: "none",
    width: "28vw",
    borderRadius: "12px",
  },
  headerModal: {
    height: "72px",
    background: "#D3DAE3",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerData1: {
    color: "#212833",
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "24px",
    marginLeft: "18px",
  },
  headerData2: {
    color: "#626B7E",
    marginRight: "18px",
    fontWeight: "600",
    cursor: "pointer",
  },
  delContent: {
    display: "flex",
  },
  delContentWithin: {
    fontWeight: "400",
    fontSize: "14px",
    color: "#626B7E",
    lineHeight: "17px",
  },
  delFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "4px",
    alignItems: "center",
  },
  cnclBtn: {
    marginRight: "10px",
    height: "37px",
    borderRadius: "6px",
    width: "85px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "17px",
    border: "1px solid #D3DAE3",
    color: "#626B7E",
    cursor: "pointer",
    "&:hover": {
      color: "#FF4848",
      border: "1px solid #FF4848",
    },
  },
  crtBtn: {
    marginRight: "18px",
    height: "37px",
    color: "#FFFFFF",
    background: "#FF4848",
    borderRadius: "6px",
    width: "85px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "17px",
    cursor: "pointer",
    "&:hover": {
      background: "#0F2F51",
    },
  },
  containBtns: {
    paddingTop: "1rem",
    justifyContent: "flex-end",
    display: "flex",
  },
  closeBtn: {
    background: "white",
    color: "#626B7E",
    fontWeight: "500",
    fontSize: "13px",
    border: "none",
    padding: "0.7rem 1.5rem",
    borderRadius: "4px",
    cursor: "pointer",
    height: "40px",
    alignSelf: "center",
  },
  containIcon: {
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: "1rem",
  },
  para: {
    color: "#616A7D",
    fontSize: "15px",
    fontWeight: "500",
  },
  sigWarnBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    background: "#FFF0D8",
    border: "1px solid #FFD38B",
  },
});
const DisconnectModal = ({ open, setOpen, setDetails, setReload,reload }) => {
  console.log({setDetails})
  const classes = styles();
  const navigate = useNavigate()
  const userDetailsSelector = useSelector((state) => state?.userDetails);
  const [loading, setLoading] = useState(false);
  // Set true when the mailbox still has signatures, which blocks disconnect
  // until the user removes them under Email Signatures.
  const [hasSignatures, setHasSignatures] = useState(false);

  // Count signatures for this OAuth mailbox. /signature/list returns a flat
  // array when account_id is passed. Without an account_id it returns the
  // ALL-mailboxes map, which can't answer "does THIS mailbox have signatures",
  // so fail open (0) rather than summing across every mailbox.
  const countMailboxSignatures = async () => {
    const accountId = setDetails?._id;
    if (!accountId) return 0;
    const url = `${CampaignSettingsEndpoints.signatureList}?account_id=${accountId}`;
    const response = await getRequest(navigate, url);
    const data = response?.data?.data;
    if (Array.isArray(data)) return data.length;
    if (data && typeof data === "object") {
      return Object.values(data).reduce(
        (n, entry) => n + (entry?.signatures?.length || 0),
        0,
      );
    }
    return 0;
  };

  const deleteRecord = async () => {
    // When true, we keep the modal open (blocked by signatures / check
    // failure) instead of closing + reloading the list in `finally`.
    let blocked = false;
    // Clear any previous block so a re-click re-runs the gate (e.g. after the
    // user has deleted the signatures under Email Signatures and comes back).
    setHasSignatures(false);
    try {
      setLoading(true);
      // OAuth mailboxes (Gmail 2 / Outlook 5 / Zoho 8) disconnect via the
      // email-keyed disconnect-inbox endpoint; API-key ESPs use delete-esp.
      if(isOAuthMailboxEsp(setDetails.esp)){
        // Signatures must be deleted before an OAuth mailbox is disconnected.
        // Check first and block the disconnect if any still exist.
        let sigCount = 0;
        try {
          sigCount = await countMailboxSignatures();
        } catch (sigErr) {
          blocked = true;
          EventEmitter.emit(
            EMITTER_ERROR,
            STRINGS.DISCONNECT_SIG_CHECK_FAILED,
          );
          return;
        }
        if (sigCount > 0) {
          blocked = true;
          setHasSignatures(true);
          EventEmitter.emit(
            EMITTER_ERROR,
            STRINGS.DISCONNECT_HAS_SIGNATURES_DESC,
          );
          return;
        }
        // DELIBERATE absolute production URL, paired with the connect call in
        // ConnectInboxScreen - the mailbox connect/disconnect flow is not usable on
        // staging, so both ends are pointed at production on purpose.
        // ⚠️ This means a disconnect performed from STAGING deletes the mailbox
        // connection in PRODUCTION. Keep that in mind when testing.
        const response = await postRequest(
          navigate,
          "https://webservicelive.reachiq.ai/auth/api/v2.0/disconnect-inbox",
          {
            email:setDetails?.email,
            // user_email:userDetailsSelector?.payload?.email
          }
        );
        const resp = response?.data?.message;
        EventEmitter.emit(EMITTER_SUCCESS, resp);
      }
      else{
        const response = await deleteRequest(
          authEndpoints.deleteEsp,
          {
            esp:setDetails.esp,
            // user_email:userDetailsSelector?.payload?.email
          },
          navigate
        );
        const resp = response?.data?.message;
        EventEmitter.emit(EMITTER_SUCCESS, resp);
      }
    } catch (err) {
      EventEmitter.emit(
        EMITTER_ERROR,
        getErrorMessage(err?.data?.data?.errors || {}, err?.data?.message)
      );
    } finally {
      setLoading(false);
      // Only close + refresh when the disconnect wasn't blocked by signatures.
      if (!blocked) {
        setReload(reload+1);
        setOpen(!open);
      }
    }
  };

  const modalHeaderData = {
    heading: {
      id: STRINGS.DIS_GMAIL,
      label: `${STRINGS.DISCONNECT} `,
    },
  };
  const modalBodyData = (
    <div className={classes.modalBody}>
      <Box className={classes.delContent}>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.REGULAR}
          label={STRINGS.ARE_YOU_SURE_DISCONNECT}
        />
      </Box>
      {hasSignatures && (
        <Box className={classes.sigWarnBanner}>
          <IconComponent
            iconLabel={ICON_LABELS.WARNING}
            color={WARNING.W_700}
            fontSize={"18px"}
          />
          <Box>
            <TypographyInline
              size={"sm"}
              color={WARNING.W_700}
              fontWeight={fontWeight.SEMIBOLD}
              label={STRINGS.DISCONNECT_HAS_SIGNATURES_TITLE}
            />
            <TypographyInline
              size={"xs"}
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
              label={STRINGS.DISCONNECT_HAS_SIGNATURES_BANNER}
            />
          </Box>
        </Box>
      )}
    </div>
  );
  const modalFooterRightData = (
    <Box className={classes.delFooter}>
      <Button
        label={STRINGS.CANCEL}
        variant={"ghost"}
        size={"sm36"}
        onClick={() => setOpen(false)}
      />
      <Button
        label={STRINGS.DISCONNECT}
        variant={"primary"}
        size={"sm36"}
        onClick={deleteRecord}
        isLoading={loading}
      />
    </Box>
  );
  const modalFooterLeftData = <div></div>;
  return (
    <CustomModal
      close={() => setOpen(false)}
      open={open}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{
        left: modalFooterLeftData,
        right: modalFooterRightData,
      }}
    />
  );
};

export default DisconnectModal;
